export const RESULT = {
    key: 'result',
    value: 'result'
};
export const INITIAL_AMOUNT = {
    key: 'initialAmount',
    value: 'initial amount'
};
export const RATE = {
    key: 'rate',
    value: 'rate'
};
export const TIME_STEPS = {
    key: 'timeSteps',
    value: 'time steps'
};
export const RATE_TYPE = {
    key: 'rateType',
    value: 'rate type'
};
export const GROWTH = 'growth';
export const DECAY = 'decay';





export const APP = 'app';
export const GAME = 'game';